module.exports = __webpack_public_path__ + "static/img/3.7c3d557.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/3.png
// module id = Jsoa
// module chunks = 0